let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  return audioCtx;
}

function playTone(frequency: number, duration: number, type: OscillatorType = 'sine') {
  const ctx = getAudioContext();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(frequency, ctx.currentTime);
  gain.gain.setValueAtTime(0.3, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start();
  osc.stop(ctx.currentTime + duration);
}

const SOUNDS: Record<string, () => void> = {
  tone_alert: () => {
    playTone(880, 0.15, 'square');
    setTimeout(() => playTone(1100, 0.15, 'square'), 180);
    setTimeout(() => playTone(880, 0.15, 'square'), 360);
  },
  chime: () => {
    playTone(523, 0.12, 'sine');
    setTimeout(() => playTone(659, 0.12, 'sine'), 140);
    setTimeout(() => playTone(784, 0.2, 'sine'), 280);
  },
  dispatch_alert: () => {
    playTone(600, 0.3, 'sawtooth');
    setTimeout(() => playTone(800, 0.3, 'sawtooth'), 350);
    setTimeout(() => playTone(1000, 0.4, 'sawtooth'), 700);
  },
  notification: () => {
    playTone(440, 0.1, 'sine');
    setTimeout(() => playTone(660, 0.15, 'sine'), 120);
  },
  urgent: () => {
    for (let i = 0; i < 5; i++) {
      setTimeout(() => playTone(1000, 0.1, 'square'), i * 200);
      setTimeout(() => playTone(800, 0.1, 'square'), i * 200 + 100);
    }
  },
  two_tone: () => {
    playTone(1000, 0.5, 'sine');
    setTimeout(() => playTone(750, 0.5, 'sine'), 550);
  },
  bell: () => {
    playTone(830, 0.3, 'triangle');
    setTimeout(() => playTone(830, 0.3, 'triangle'), 400);
  },
  soft_chime: () => {
    playTone(659, 0.14, 'sine');
    setTimeout(() => playTone(988, 0.25, 'sine'), 150);
  },
  ding_dong: () => {
    playTone(784, 0.25, 'sine');
    setTimeout(() => playTone(587, 0.35, 'sine'), 270);
  },
  triple_chime: () => {
    playTone(698, 0.12, 'sine');
    setTimeout(() => playTone(880, 0.12, 'sine'), 140);
    setTimeout(() => playTone(1047, 0.22, 'sine'), 280);
  },
  bubble: () => {
    playTone(494, 0.08, 'sine');
    setTimeout(() => playTone(740, 0.1, 'sine'), 90);
    setTimeout(() => playTone(988, 0.14, 'sine'), 190);
  },
  glass: () => {
    playTone(1319, 0.1, 'triangle');
    setTimeout(() => playTone(1760, 0.18, 'triangle'), 110);
  },
  marimba: () => {
    playTone(587, 0.12, 'triangle');
    setTimeout(() => playTone(784, 0.12, 'triangle'), 130);
    setTimeout(() => playTone(1175, 0.2, 'triangle'), 260);
  },
  ping: () => {
    playTone(1047, 0.12, 'sine');
    setTimeout(() => playTone(1568, 0.16, 'sine'), 120);
  },
  none: () => {},
};

export function playSound(soundName: string): void {
  const fn = SOUNDS[soundName];
  if (fn) {
    fn();
  } else {
    SOUNDS.notification();
  }
}

export const AVAILABLE_SOUNDS = Object.keys(SOUNDS);
